import { execAdmin } from '@src/apis/reware/utils';

import type {
  DeletePricingRuleResult,
  DeletePricingRuleExecVariables,
  DeletePricingRuleExecResponse,
} from './types';

export interface DeletePricingRuleArgs {
  partnerId: number;
  ruleId: number;
}

export const deletePricingRule = async ({
  partnerId,
  ruleId,
}: DeletePricingRuleArgs): Promise<DeletePricingRuleResult> => {
  const query = `
    mutation deletePricingRule(
      $partnerId: Int!
      $ruleId: Int!
    ) {
      partner(id: $partnerId) {
        deletePricingRule(ruleId: $ruleId) {
          success
        }
      }
    }
  `;

  const data = await execAdmin<DeletePricingRuleExecVariables, DeletePricingRuleExecResponse>(
    query,
    { variables: { partnerId, ruleId } }
  );

  return data.partner.deletePricingRule;
};
